export const ENDPOINTS = {
  subscription: {
    main: "subscription",
    otherSettings: "subscription/otherSettings/admin",
    snitcherSettings: "subscription/snitcherSettings/admin",
    // algorithmSettings: "subscription/AlgorithmSettings/admin",
    exists: "subscription/exists",
    users: "subscription/users",
    multiCustomerInvite: "subscription/multiCustomer/invite",
    resetPassword: "subscription/user/password",
    signupEnable: "subscription/signup/enable",
    bucket: "subscription/bucket",
    paymentCustomer: "subscription/PaymentCustomer",
  },
  auth: {
    login: "auth/admin/login",
    me: "auth/admin/me",
    password: "auth/admin/password",
    logout: {
      admin: "auth/logout/admin",
    },
  },
  phoneNumber: {
    admin: "phonenumber/admin",
  },
  csrf: {
    admin: "csrf/admin",
  },
  user: {
    main: "user",
    exists: "user/exists",
  },
  scrape: {
    metrics: "scrape/metrics",
  },
  documents: {
    sync: "Documents/Sync",
    syncQaAnswers: "Documents/Sync/QaAnswers",
  },
};
